import { createContext, useContext } from "react";
const ChatContext = createContext({
  app_name: null,
  supabase_public: null,
  supabase_public_chat: null,
  isChatWithAi: false,
  chatroomList: [],
  currentChatroom: null,
  setCurrentChatroom: () => {
  },
  setChatroomList: () => {
  },
  messages: [],
  setMessages: () => {
  },
  isGenerating: false,
  setIsGenerating: () => {
  },
  botMessage: "",
  setBotMessage: () => {
  },
  isCompareFilesModalShow: false,
  setIsCompareFilesModalShow: () => {
  },
  isFilesModalShow: false,
  setIsFilesModalShow: () => {
  },
  isRemoveFileModalShow: false,
  setIsRemoveFileModalShow: () => {
  },
  user: null,
  setUser: () => {
  },
  bidContactDocumentName: "",
  setBidContactDocumentName: () => {
  },
  specificationDocumentName: "",
  setSpecificationDocumentName: () => {
  },
  files: [],
  setFiles: () => {
  },
  toastInfo: { message: "" },
  setToastInfo: () => {
  },
  editFileState: {
    isRemoveOpen: false,
    fileName: ""
  },
  isEditChatroomModalShow: false,
  setIsEditChatroomModalShow: () => {
  },
  editChatroomState: "Create",
  setEditChatroomState: () => {
  },
  setEditFileState: () => {
  },
  selectFileType: null,
  setSelectFileType: () => {
  },
  removeFileName: null,
  setRemoveFileName: () => {
  },
  isFillFormModalShow: false,
  setIsFillFormModalShow: () => {
  },
  isAddBotModalShow: false,
  setIsAddBotModalShow: () => {
  },
  isRemoveChatroomModalShow: false,
  setIsRemoveChatroomModalShow: () => {
  },
  isOpenNewFriendModal: false,
  setIsOpenNewFriendModal: () => {
  },
  isInvitationListModalShow: false,
  setIsInvitationListModalShow: () => {
  }
});
const useChatroom = (context = ChatContext) => useContext(context);
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
export {
  ChatContext as C,
  __awaiter as _,
  getAugmentedNamespace as a,
  __rest as b,
  commonjsGlobal as c,
  getDefaultExportFromCjs as g,
  useChatroom as u
};
